import React from 'react';
type EcgLineProps = {
  className?: string;
  animated?: boolean;
  beats?: number;
  strokeClassName?: string;
};
export function EcgLine({
  className = '',
  animated = false,
  beats = 6,
  strokeClassName = 'stroke-pulse'
}: EcgLineProps) {
  const width = beats * 200;
  return <svg viewBox={`0 0 ${width} 60`} preserveAspectRatio="none" className={className} aria-hidden="true" focusable="false" data-id="element-45" data-mp="akz06nnvqjb9">
      <path d={buildPath(beats)} fill="none" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke" className={`${strokeClassName} ${animated ? 'animate-ecg' : ''}`} data-id="element-46" data-mp="ybl7gcq27zk7" />
    </svg>;
}
function buildPath(beats: number): string {
  let d = 'M0 34';
  for (let i = 0; i < beats; i++) {
    const x = i * 200;
    d += ` H${x + 50} Q${x + 58} 24 ${x + 66} 34 H${x + 82} L${x + 88} 40 L${x + 96} 4 L${x + 104} 56 L${x + 110} 34 H${x + 128} Q${x + 142} 18 ${x + 156} 34 H${x + 200}`;
  }
  return d;
}